export type WorkModalityEnum = 'HYBRID' | 'OFFICE' | 'REMOTE';

export const WorkModalityEnumValues = {
    Hybrid: 'HYBRID' as WorkModalityEnum,
    Office: 'OFFICE' as WorkModalityEnum,
    Remote: 'REMOTE' as WorkModalityEnum,
};
